import React, { useState, useEffect, useMemo } from "react";
import "../../Assests/Scss/AddUpdateQuestions.scss";
import Loading from "../../../../Student/Reusablecomponents/Loading";
import ScenarioQuestionformat from "../../../../Student/Reusablecomponents/ScenarioQuestionformat";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "../../../../Student/Reusablecomponents/DataTable/DataTable";
import DropdownValues from "../../../../Student/Reusablecomponents/DropDownValues";
import {
  MainSource,
  SubMainSource,
  QVStatus,
  DDContent,
  DDTopic,
  DDSubTopic,
  DDLearningOC,
  DDSubLearningOC,
  NCERTLO,
  QuestionLevel,
  FormQuestions,
  BloomTaxonomy,
  DDContext,
  DDSystem,
  DDStream,
  DDSubSytem,
  DDCompetencies,
  DDSubCompetencies,
  DDProcedural,
  DDEpistemic,
  DDContextOne,
  DDContextTwo,
  DDContextThree,
} from "../../../../ReusableComponents/QBDropdowns";
import { GoTriangleDown } from "react-icons/go";
import { Row, Col } from "react-bootstrap";
import TinyMCEDitor from "../../../../ReusableComponents/tinymceEditor";
import notify from "../../../../ReusableComponents/ToastifyAlerts";
import { IoInformationCircleOutline } from "react-icons/io5";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import * as Yup from "yup";
import QS from "../../Assests/images/QuestionSource.svg";
import Q from "../../Assests/images/Question.svg";
import LO from "../../Assests/images/LO.svg";
import AP from "../../Assests/images/AParameters.svg";
import Forms from "../../Assests/images/Forms.svg";
import {
  AnswerType,
  AnswerValuetype,
  UnitsDD,
} from "../../../../ReusableComponents/QBDropdowns";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import { InputType } from "../../../../ReusableComponents/CommonFunctions";
import axiosInstance from "../../../../ReusableComponents/Axios";
import QBCList from "../../../../ReusableComponents/QBCheckList";
import {
  StageDD, CircularGoalDD, CompetenciesDD,
} from "../../../../ReusableComponents/QBAdmin/CommonDropdowns";
// import { IoInformationCircleOutline } from "react-icons/io5";
// import { IoMdCloseCircleOutline } from "react-icons/io";
// import DataTable from "../../../../Student/Reusablecomponents/DataTable/DataTable";
const AddUpdateQuestions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const GetQuestion = useSelector(
    (state) => state.QuestionDeatils.QuestionDetails
  );
  const Scenario = useSelector(
    (state) => state.ScenarioDeatils.ScenarioDetails
  );
  const FQuestionDetails = useSelector((state) => state.FQDetails.FQDetails);
  const [Load, SetLoad] = useState(false);
  const [MDQ, SetMDQ] = useState(
    GetQuestion
      ? GetQuestion?.questionType
      : location.state?.Tab === "INQ"
        ? "D"
        : "M"
  );

  const [Accordion, SetAccordion] = useState("All");

  const [EditorValues, SetEditorValues] = useState({
    Question: GetQuestion?.question || "",
    Answer: GetQuestion?.answer || "",
    OptionA: GetQuestion?.optionA || "",
    OptionB: GetQuestion?.optionB || "",
    OptionC: GetQuestion?.optionC || "",
    OptionD: GetQuestion?.optionD || "",
    Explanation: GetQuestion?.answerExplanation || "",
    Misconception: GetQuestion?.misconception || "",
  });
  const [OComments, SetOComments] = useState({
    Source: GetQuestion?.otherQSource || "",
    Verification: GetQuestion?.verificationComment || "",
    Form: GetQuestion?.otherFormComments || "",
  });

  const [NTBased, SetNTBased] = useState(GetQuestion?.sSourceLovId || "");
  const [SNTBased, SetSNTBased] = useState(GetQuestion?.sSourceValueId || "");
  const [VStatus, SetVStatus] = useState(GetQuestion?.qStatus || "");

  const [Content, SetContent] = useState(GetQuestion?.content || "");
  const [Topic, SeTopic] = useState(
    GetQuestion?.topic || FQuestionDetails?.topicId || ""
  );
  const [SubTopic, SetSubTopic] = useState(
    GetQuestion?.subTopic || FQuestionDetails?.subTopicId || ""
  );
  const [LOC, SetLOC] = useState(
    GetQuestion?.lo || FQuestionDetails?.loid || ""
  );
  const [SubLOC, SetSubLOC] = useState(
    GetQuestion?.subLO || FQuestionDetails?.subLOId || ""
  );
  const [NCERTLOC, SetNCERTLOC] = useState(GetQuestion?.ncertlo || "");
  const [GetGrade, SetGetGrade] = useState();
  const [CNumber, SetCNumber] = useState();
  const [ChapterOpt, SetChapterOpt] = useState();
  const [GradeOpt, SetGradeOpt] = useState();
  const [QLevel, SetQLevel] = useState(
    GetQuestion?.[items?.subjectId === "1" ? "level" : "questionLevel"] || ""
  );

    const [SStage, SetSStage] = useState(GetQuestion?.stage || "");
    const [SCGoal, SetSCGoal] = useState(GetQuestion?.curricularGoal || "");
    const [Competencie, SetCompetencie] = useState(GetQuestion?.competency || "");

  const [BTaxonomy, SetBTaxonomy] = useState(GetQuestion?.bloomsTaxonomy || "");
  const [Context, SetContext] = useState(GetQuestion?.context || "");

  const [FormQ, SetFormQ] = useState(GetQuestion?.elementType || []);

  const [AQErrors, SetAQErrors] = useState({});

  const [NCERTDetails, SetNCERTDetails] = useState();
  const [OpenNCERTTable, closeNCERTTable] = useState(false);

  // Below are the science variables
  const [SSS, SetSSS] = useState({
    System: GetQuestion?.system || "",
    Stream: GetQuestion?.stream || "",
    SubSytem: GetQuestion?.subSystem || "",
  });

  const [Competencies, SetCompetencies] = useState({
    Competencies: GetQuestion?.competencies || "",
    SubCompetencies: GetQuestion?.subCompetencies || "",
  });
  const [Knowledge, SetKnowledge] = useState({
    Procedural: GetQuestion?.proceduralKnowledge || "",
    Epistemic: GetQuestion?.epistemicKnowledge || "",
  });

  const [ScienceContext, SetScienceContext] = useState({
    ContextOne: GetQuestion?.contextLevel1 || "",
    ContextTwo: GetQuestion?.contextLevel2 || "",
    ContextThree: GetQuestion?.contextLevel3 || "",
  });

  // Below are the input Question Type
  const [AType, SetAType] = useState(GetQuestion?.answerType || "");
  const [AVType, SetAVType] = useState(GetQuestion?.answerValType || "");
  const [Units, SetUnits] = useState(GetQuestion?.unitId || "");

  const [MultipleInputs, setMultipleInputs] = useState(
    (GetQuestion?.answerValue?.length
      ? GetQuestion?.answerValue?.split(",")
      : GetQuestion?.answer?.split(",")) || [""]
  );
  const [RangeValues, SetRangevalues] = useState({
    From: GetQuestion?.answerValue?.split(",")?.[0]?.trim() || "",
    To: GetQuestion?.answerValue?.split(",")?.[1]?.trim() || "",
  });

    const [OpenDeatils, SetOpenDeatils] = useState(false);
  const [FSCGoal, SetFSCGoal] = useState();
  const [FCompetencie, SetFCompetencie] = useState();

  const handleAddInput = () => {
    if (MultipleInputs.length < 5) {
      setMultipleInputs([...MultipleInputs, ""]);
    } else {
      alert("A maximum of 5 answers only can be added.");
    }
  };

  const handleRemoveInput = (index) => {
    const newInputs = MultipleInputs.filter((_, i) => i !== index);
    setMultipleInputs(newInputs);
  };

  const handleChange = (index, e) => {
    if (AVType?.Name === "S") {
      StoreEditorValues("Answer", e.target.value.slice(0, 10));
    } else {
      const newInputs = [...MultipleInputs];
      switch (AType?.Name) {
        case "T":
          const CONVERT = e.target.value.replace(/[^a-zA-Z]/g, "");
          newInputs[index] = CONVERT;
          break;
        case "F":
          const CONVER = e.target.value
            .replace(/[^a-zA-Z0-9]/g, "")
            .slice(0, 3);
          newInputs[index] = CONVER;
          break;
        default:
          newInputs[index] = e.target.value.slice(0, 10);
          break;
      }
      setMultipleInputs(newInputs);
    }
  };
  // Above are the input Question Type

  const StoreSSS = (Name, e) => {
    SetSSS({ ...SSS, [Name]: e });
  };

  const StoreCompetencies = (Name, e) => {
    SetCompetencies({ ...Competencies, [Name]: e });
  };

  const StoreKnowledge = (Name, e) => {
    SetKnowledge({ ...Knowledge, [Name]: e });
  };

  const StoreContext = (Name, e) => {
    SetScienceContext({ ...ScienceContext, [Name]: e });
  };

  const validationSchema = Yup.object().shape({
    NTBased: Yup.string().required("Source is required"),
    SNTBased: Yup.string().required("Source is required"),

    VStatus: Yup.string().required("Question Verification status is required"),
    Question: Yup.string().required("Question is required"),
    Answer: Yup.string().when("AVType", {
      is: () => AVType?.Name === "S" || MDQ === "M",
      then: (schema) => Yup.string().required("Answer is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    MultipleInputs: Yup.array().when("AVType", {
      is: () => AVType?.Name === "M",
      then: (schema) =>
        schema
          .required("Answers are required")
          .min(1, "At least one answer is required")
          .test("", "Answers are required", (arr) => {
            return (
              Array.isArray(arr) &&
              arr.every(
                (item) => typeof item === "string" && item.trim().length > 0
              )
            );
          }),
      otherwise: (schema) => schema.notRequired(),
    }),
    From: Yup.string().when("AVType", {
      is: () => AVType?.Name === "R",
      then: (schema) => schema.required("Range From is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    To: Yup.string().when("AVType", {
      is: (AVType) => AVType?.Name === "R",
      then: (schema) =>
        schema
          .required("Range To is required")
          .test(
            "is-greater",
            "Range To should be greater than Range From",
            function (value) {
              const { From } = this.parent;
              if (!From || !value) return true; // skip if either is empty
              return Number(value) > Number(From);
            }
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
    OptionA: Yup.string().when("MDQ", {
      is: () => MDQ === "M",
      then: (schema) => Yup.string().required("Option A is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),

    OptionB: Yup.string().when("MDQ", {
      is: () => MDQ === "M",
      then: () => Yup.string().required("Option B is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    QForm: Yup.string().required("Forms in Question is required"),
    Form: Yup.string().when("FormQ", {
      is: (FormQ) => FormQ.includes(4002),
      then: (schema) => Yup.string().required("Form input Field is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Source: Yup.string().when("SNTBased", {
      is: (SNTBased) => SNTBased === 3574 || SNTBased === 3578,
      then: (schema) => Yup.string().required("Source input Field is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Content: Yup.string().when("1", {
      is: () => items?.subjectId === "1",
      then: (schema) => Yup.string().required("Content is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Topic: Yup.string().required("Topic is required"),
    SubTopic: Yup.string().required("Sub Topic is required"),
    LOC: Yup.string().required("Learning Outcomes is required"),
    GetGrade: Yup.string().required("Grade is required"),
    CNumber: Yup.string().required("Chapter is required"),

    SStage: Yup.string().required("Stage is required"),
    SCGoal: Yup.string().required("Curricular Goal is required"),
    Competencie: Yup.string().required("Competencies is required"),

    QLevel: Yup.string().required("Question level is required"),
    BTaxonomy: Yup.string().required("Bloom's Taxonomy is required"),
    Context: Yup.string().when("1", {
      is: () => items?.subjectId === "1",
      then: (schema) => Yup.string().required("Context is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    // Below is for science
    System: Yup.string().when("2", {
      is: () => items?.subjectId === "2",
      then: (schema) => Yup.string().required("System is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Stream: Yup.string().when("2", {
      is: () => items?.subjectId === "2",
      then: (schema) => Yup.string().required("Stream is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    SubSytem: Yup.string().when("2", {
      is: () => items?.subjectId === "2",
      then: (schema) => Yup.string().required("SubSytem is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),

    Competencies: Yup.string().when("2", {
      is: () => items?.subjectId === "2",
      then: (schema) => Yup.string().required("Competencies is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    SubCompetencies: Yup.string().when("2", {
      is: () => items?.subjectId === "2",
      then: (schema) => Yup.string().required("Sub-Competencies is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Procedural: Yup.string().when("2", {
      is: () => items?.subjectId === "2",
      then: (schema) => Yup.string().required("Procedural is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Epistemic: Yup.string().when("2", {
      is: () => items?.subjectId === "2",
      then: (schema) => Yup.string().required("Epistemic is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    ContextOne: Yup.string().when("2", {
      is: () => items?.subjectId === "2",
      then: (schema) => Yup.string().required("ContextOne is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    ContextTwo: Yup.string().when("2", {
      is: () => items?.subjectId === "2",
      then: (schema) => Yup.string().required("ContextTwo is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    ContextThree: Yup.string().when("2", {
      is: () => items?.subjectId === "2",
      then: (schema) => Yup.string().required("ContextThree is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Units: Yup.string().when("2", {
      is: () => AType?.Name === "U",
      then: (schema) => Yup.string().required("Units is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
  });

  const OpenAccordain = (e) => {
    if (Accordion === e) {
      SetAccordion();
    } else {
      SetAccordion(e);
    }
  };

  const StoreEditorValues = (Name, Values) => {
    SetEditorValues({ ...EditorValues, [Name]: Values });
  };
  const HandelOComments = (Name, Values) => {
    SetOComments({ ...OComments, [Name]: Values });
  };
  const FormSOptions = (e) => {
    if (FormQ.includes(NaN)) {
      SetFormQ([e]);
    } else {
      if (FormQ.includes(e)) {
        SetFormQ((prevItems) => prevItems.filter((item) => item !== e));
      } else {
        SetFormQ([...FormQ, e]);
      }
    }
  };
  const QForm = FormQ?.join(",");

  useEffect(() => {
    if (LOC) {
      GETChaptergrade();
    }
  }, [LOC]);

  const GETChaptergrade = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/QuestionBank/GetGradeAndChapterByLO?LovId=${LOC}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const ChapterOp = [];
        const GradeOp = [];
        res.data.map((item) => {
          if (
            !ChapterOp.some((chapter) => chapter.value === item.chapterLovId)
          ) {
            ChapterOp.push({
              display: item.chapterName,
              value: item.chapterLovId,
            });
          }
          if (!GradeOp.some((grade) => grade.value === item.gradeLovId)) {
            GradeOp.push({ display: item.gradeName, value: item.gradeLovId });
          }
        });
        SetChapterOpt(ChapterOp);
        SetGradeOpt(GradeOp);

        SetCNumber(
          ChapterOp.some((item) => item.value === GetQuestion?.chapterId)
            ? GetQuestion?.chapterId
            : ""
        );
        SetGetGrade(
          GradeOp.some((item) => item.value === GetQuestion?.gradeId)
            ? GetQuestion?.gradeId
            : ""
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const NCERTColumns = [
    { name: "LO Code", selector: "lovName", sortable: true },
    {
      name: "Description",
      selector: "description",
      sortable: true,
      cell: (row) => (
        <div style={{ textAlign: "justify" }}>{row.description} </div>
      ),
    },
  ];
  const AddQuestion = async () => {
    SetLoad((prev) => !prev);
    const QuestionInputs = {
      questionID: 0,

      scenarioID: Scenario?.scenarioID || location.state?.SID || 0,
      subjectId: items?.subjectId,

      questionType: MDQ,
      // "qSource": "string",
      sSourceLovId: NTBased,
      sSourceId: SNTBased,
      otherQSource: OComments?.Source,
      qStatus: VStatus,
      verificationComment: OComments?.Verification,

      question: EditorValues?.Question.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      answer: EditorValues?.Answer.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionA: EditorValues?.OptionA.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionB: EditorValues?.OptionB.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionC: EditorValues?.OptionC.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionD: EditorValues?.OptionD.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionE: "",
      answerExplanation: EditorValues?.Explanation,
      misconception: EditorValues?.Misconception,

      createdBy: items?.userId,
      modifiedBy: items?.userId,

      content: Content,
      topic: Topic,
      subTopic: SubTopic,
      lo: LOC,
      subLO: SubLOC || 0,
      ncertlo: NCERTLOC || 0,
      gradeId: GetGrade,
      chapterId: CNumber,

      context: Context,
      bloomsTaxonomy: BTaxonomy,
      level: QLevel,

      elementType: QForm,
      otherFormComments: OComments?.Form,

      isClone: 0,
      parentQBID: 0,
      AnswerType: AType?.Value || 0,
      AnswerValType: AVType?.Value || 0,
      AnswerValue:
        AVType?.Name === "M"
          ? MultipleInputs?.join(",")
          : (AVType?.Name === "R" &&
            `${RangeValues?.From},${RangeValues?.To}`) ||
          "",

      UnitId: Units || 0,
      addScenarioQuestionChecklist: QCValues,
       stage: SStage,
        curricularGoal: SCGoal,
        competency: Competencie,
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL + `/QuestionBank/AddMathsQuestion`,
        QuestionInputs,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        switch (res.data) {
          case 1: notify("Question added successfully", "success");
            navigate(-1);
            break;
          case 999: notify("Question Already Exists", "warning");
            break;
          default: notify("Question not added. Please try again", "error");
            break;
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        notify("Question not added. Please try again", "error");
        SetLoad((prev) => !prev);
      });
  };

  const Validation = () => {
    const AllFields = {
      ...EditorValues,
      NTBased,
      SNTBased,
      VStatus,
      Content,
      Topic,
      SubTopic,
      LOC,
      SubLOC,
      NCERTLOC,
      GetGrade,
      CNumber,SStage, SCGoal, Competencie,
      QLevel,
      BTaxonomy,
      Context,
      QForm,
      ...OComments,
      FormQ,
      ...SSS,
      ...Competencies,
      ...Knowledge,
      ...ScienceContext,
      Units,
      MultipleInputs,
      AVType,
      ...RangeValues,
    };
    validationSchema
      .validate(AllFields, { abortEarly: false })
      .then(() => {
        SetAQErrors({});
        if (CValidation) {
          if (items?.subjectId === "1") {
            if (GetQuestion) {
              UpdateQuestion(AllFields);
            } else {
              AddQuestion(AllFields);
            }
          } else {
            if (GetQuestion) {
              UpdateScienceQuestion(AllFields);
            } else {
              AddScienceQuestion(AllFields);
            }
          }
        }
      })
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            newErrors[error.path] = error.message;
          });
        }
        SetAQErrors(newErrors);
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
  };
  const UpdateQuestion = async () => {
    SetLoad((prev) => !prev);
    const QuestionInputs = {
      questionID: GetQuestion?.questionID,

      scenarioID: Scenario?.scenarioID || GetQuestion?.scenarioID || 0,
      subjectId: items?.subjectId,

      questionType: MDQ,
      sSourceLovId: NTBased,
      sSourceId: SNTBased,
      otherQSource: OComments?.Source,
      qStatus: VStatus,
      verificationComment: OComments?.Verification,

      question: EditorValues?.Question.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      answer: EditorValues?.Answer.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionA: EditorValues?.OptionA.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionB: EditorValues?.OptionB.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionC: EditorValues?.OptionC.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionD: EditorValues?.OptionD.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionE: "",
      answerExplanation: EditorValues?.Explanation,
      misconception: EditorValues?.Misconception,

      createdBy: items?.userId,
      modifiedBy: items?.userId,

      content: Content,

      topic: Topic,
      subTopic: SubTopic,
      lo: LOC,
      subLO: SubLOC || 0,
      ncertlo: NCERTLOC || 0,
      gradeId: GetGrade,
      chapterId: CNumber,

      context: Context,
      bloomsTaxonomy: BTaxonomy,
      level: QLevel,

      elementType: QForm,
      otherFormComments: OComments?.Form,

      isClone: 0,
      parentQBID: 0,
      AnswerType: AType?.Value || 0,
      AnswerValType: AVType?.Value || 0,
      AnswerValue:
        AVType?.Name === "M"
          ? MultipleInputs?.join(",")
          : (AVType?.Name === "R" &&
            `${RangeValues?.From},${RangeValues?.To}`) ||
          "",

      UnitId: Units || 0,
      addScenarioQuestionChecklist: QCValues,
       stage: SStage,
        curricularGoal: SCGoal,
        competency: Competencie,
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL +
        `/QuestionBank/UpdateMathsQuestion`,
        QuestionInputs,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        notify("Question updated successfully", "success");
        SetLoad((prev) => !prev);
        navigate(-1);
      })
      .catch((err) => {
        notify("Question not updated. Please try again", "error");
        SetLoad((prev) => !prev);
      });
  };

  const CloneQuestion = () => {
    if (location.pathname.includes("/OverallDashboard")) {
      navigate("/QBAdmin/OverallDashboard/CloneAddQuestion", {
        state: { Tab: location.state?.Tab },
      });
    } else if (location.pathname.includes("/QuestionStatus")) {
      navigate("/QBAdmin/QuestionStatus/CloneAddQuestion", {
        state: { Tab: location.state?.Tab },
      });
    } else if (location.pathname.includes("/Progresstracker")) {
      navigate("/QBAdmin/Progresstracker/CloneAddQuestion", {
        state: { Tab: location.state?.Tab },
      });
    } else {
      navigate("/QBAdmin/QuestionBank/CloneAddQuestion", {
        state: { Tab: location.state?.Tab },
      });
    }
  };

  const AddScienceQuestion = async () => {
    SetLoad((prev) => !prev);
    const QuestionInputs = {
      questionId: 0,
      scenarioID: Scenario?.scenarioID || location.state?.SID || 0,

      questionType: MDQ,
      sSourceLovId: NTBased,
      sSourceId: SNTBased,
      otherQSource: OComments?.Source,
      qStatus: VStatus,
      verificationComment: OComments?.Verification,

      question: EditorValues?.Question.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      answer: EditorValues?.Answer.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionA: EditorValues?.OptionA.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionB: EditorValues?.OptionB.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionC: EditorValues?.OptionC.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionD: EditorValues?.OptionD.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionE: "",

      answerExplanation: EditorValues?.Explanation,
      misconception: EditorValues?.Misconception,

      createdBy: items?.userId,
      modifiedBy: 0,

      system: SSS.System,
      stream: SSS.Stream,
      subSystem: SSS.SubSytem,
      scienceTopic: Topic,
      scienceSubTopic: SubTopic,
      scienceLO: LOC,
      scienceSubLO: SubLOC || 0,
      scienceNCERTLO: NCERTLOC || 0,
      gradeId: GetGrade,
      chapterId: CNumber,

      questionLevel: QLevel,
      bloomsTaxonomy: BTaxonomy,
      competencies: Competencies.Competencies,
      subCompetencies: Competencies.SubCompetencies,
      proceduralKnowledge: Knowledge.Procedural,
      epistemicKnowledge: Knowledge.Epistemic,
      contextLevel1: ScienceContext.ContextOne,
      contextLevel2: ScienceContext.ContextTwo,
      contextLevel3: ScienceContext.ContextThree,

      elementType: QForm,
      otherFormTypeComments: OComments?.Form,
      AnswerType: AType?.Value || 0,
      AnswerValType: AVType?.Value || 0,
      AnswerValue:
        AVType?.Name === "M"
          ? MultipleInputs?.join(",")
          : (AVType?.Name === "R" &&
            `${RangeValues?.From},${RangeValues?.To}`) ||
          "",

      UnitId: Units || 0,
      addScenarioQuestionChecklist: QCValues,
       stage: SStage,
        curricularGoal: SCGoal,
        competency: Competencie,
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL +
        `/ScienceQuestionBank/AddScienceQuestion`,
        QuestionInputs,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
           switch (res.data) {
          case 1: notify("Question added successfully", "success");
            navigate(-1);
            break;
          case 999: notify("Question Already Exists", "warning");
            break;
          default: notify("Question not added. Please try again", "error");
            break;
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
        notify("Question not added. Please try again", "error");
        SetLoad((prev) => !prev);
      });
  };

  const UpdateScienceQuestion = async () => {
    const QuestionInputs = {
      questionId: GetQuestion?.questionID,

      scenarioID: Scenario?.scenarioID || GetQuestion?.scenarioID || 0,
      questionType: MDQ,

      sSourceLovId: NTBased,
      sSourceId: SNTBased,
      otherQSource: OComments?.Source,

      qStatus: VStatus,
      verificationComment: OComments?.Verification,

      question: EditorValues?.Question.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      answer: EditorValues?.Answer.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionA: EditorValues?.OptionA.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionB: EditorValues?.OptionB.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionC: EditorValues?.OptionC.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionD: EditorValues?.OptionD.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionE: "",
      answerExplanation: EditorValues?.Explanation,
      misconception: EditorValues?.Misconception,

      createdBy: items?.userId,
      modifiedBy: items?.userId,

      system: SSS.System,
      stream: SSS.Stream,
      subSystem: SSS.SubSytem,
      scienceTopic: Topic,
      scienceSubTopic: SubTopic,
      scienceLO: LOC,
      scienceSubLO: SubLOC || 0,
      scienceNCERTLO: NCERTLOC || 0,
      chapterId: CNumber,
      gradeId: GetGrade,

      questionLevel: QLevel,
      bloomsTaxonomy: BTaxonomy,

      competencies: Competencies.Competencies,
      subCompetencies: Competencies.SubCompetencies,
      proceduralKnowledge: Knowledge.Procedural,
      epistemicKnowledge: Knowledge.Epistemic,
      contextLevel1: ScienceContext.ContextOne,
      contextLevel2: ScienceContext.ContextTwo,
      contextLevel3: ScienceContext.ContextThree,
      elementType: QForm,
      otherFormTypeComments: OComments?.Form,
      AnswerType: AType?.Value || 0,
      AnswerValType: AVType?.Value || 0,
      AnswerValue:
        AVType?.Name === "M"
          ? MultipleInputs?.join(",")
          : (AVType?.Name === "R" &&
            `${RangeValues?.From},${RangeValues?.To}`) ||
          "",

      UnitId: Units || 0,
      addScenarioQuestionChecklist: QCValues,
       stage: SStage,
        curricularGoal: SCGoal,
        competency: Competencie,
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL +
        `/ScienceQuestionBank/UpdateScienceQuestion`,
        QuestionInputs,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        notify("Question updated successfully", "success");
        SetLoad((prev) => !prev);
        navigate(-1);
      })
      .catch((err) => {
        notify("Question not updated. Please try again", "error");
        SetLoad((prev) => !prev);
      });
  };
  const changequestionType = (e) => {
    SetMDQ(e.target.value);
    if (!GetQuestion) {
      SetEditorValues({ ...EditorValues, Answer: "" });
    }
    SetAType("");
    SetUnits("");
    setMultipleInputs([""]);
    SetAVType("");
    SetRangevalues({ From: "", To: "" });
  };
  const inputValue = (index) => {
    if (AVType?.Name === "S") {
      return EditorValues.Answer;
    } else {
      return MultipleInputs[index].trim();
    }
  };

  useMemo(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const [HitCLV, SetHitCLV] = useState(false);
  const [CValidation, SetCValidation] = useState(false);
  const [QCValues, SetQCValues] = useState();
  useEffect(() => {
    if (CValidation) {
      Validation();
    }
  }, [CValidation]);

    const Columns = [
    { name: "Code", selector: "lovName", sortable: true },
    {
      name: "Description", selector: "lovDescription", sortable: true,
      cell: (row) => (<div style={{ textAlign: "justify" }}>{row.lovDescription} </div>),
    },
  ];
  return (
    <>
      <div className="dflex JSBetween alignitems">
        <div></div>
        {GetQuestion && items.subjectId === "1" && (
          <button className="Buttons" onClick={CloneQuestion}>
            Clone Question
          </button>
        )}{" "}
      </div>
      <div className="MainHeading mb-3">
        {GetQuestion ? "Update" : "Add"} Question
      </div>
      {(location.state?.SID || Scenario?.scenarioID) ? (
        <div className="Card mb-3">
          <div className="SubHeading mb-2">
            Scenario (Id -
            {Scenario?.scenarioID || location.state?.SID}
            )
          </div>
          <ScenarioQuestionformat scenario={Scenario?.scenarioName || location.state?.SName} />
        </div>
      ) : ""}

      <div className="Card">
        {GetQuestion && (
          <div className="SubHeading mb-2">
            Question (Id - {GetQuestion?.questionID})
          </div>
        )}
        <div className="dflex alignitems mb-2 gap-4">
          {["M", "D"].map((item) => (
            <div className="dflex alignitems gap-1">
              <input
                type="radio"
                value={item}
                checked={item === MDQ}
                name="Qtype"
                disabled={location.state?.Tab === "INQ" || GetQuestion}
                onChange={(e) => changequestionType(e)}
              />{" "}
              {item === "M" ? "MCQ" : "NON MCQ"}
            </div>
          ))}
        </div>
        <div>
          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={QS} alt="Question Source" />{" "}
                <div>
                  Question<span className="text-danger">*</span>
                </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("QS")} />
            </div>
            {Accordion !== "QS" && (
              <div className="container-fluid mt-2">
                <Row>
                  <Col>
                    <MainSource
                      className="NCLDropdown w-100 mb-2"
                      StoreMSource={SetNTBased}
                      SOption={NTBased}
                      onChange={(e) => SetNTBased(e)}
                      LID={SelectLanguage}
                      labelname={
                        <div className="DropdownHeader">
                          Source<span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.NTBased && (
                      <span className="error-message">{AQErrors?.NTBased}</span>
                    )}
                    <SubMainSource
                      className="NCLDropdown w-100"
                      StoreSMSource={SetSNTBased}
                      SOption={SNTBased}
                      PId={NTBased}
                      LID={SelectLanguage}
                      onChange={(e) => SetSNTBased(e)}
                    />
                    {AQErrors?.SNTBased && (
                      <span className="error-message">
                        {AQErrors?.SNTBased}
                      </span>
                    )}

                    {(SNTBased === 3574 || SNTBased === 3578) && (
                      <input
                        type="text"
                        className="Search mt-2 p-1 w-100"
                        onChange={(e) =>
                          HandelOComments("Source", e.target.value)
                        }
                        placeholder="Enter Comments"
                      />
                    )}
                    {AQErrors?.Source && (
                      <span className="error-message">{AQErrors?.Source}</span>
                    )}
                    <QVStatus
                      className="NCLDropdown w-100 mb-2"
                      StoreValue={SetVStatus}
                      SOption={VStatus}
                      LID={SelectLanguage}
                      onChange={(e) => SetVStatus(e)}
                    />
                    {AQErrors?.VStatus && (
                      <span
                        className="error-message"
                        style={{ marginLeft: "10px" }}
                      >
                        {AQErrors?.VStatus}{" "}
                      </span>
                    )}
                    <input
                      type="text"
                      placeholder="Enter text"
                      className="Search p-1 w-100"
                      value={OComments?.Verification}
                      onChange={(e) =>
                        HandelOComments("Verification", e.target.value)
                      }
                    />
                  </Col>
                  <Col>
                    {" "}
                    <div className="DropdownHeader">
                      Question<span>*</span>
                    </div>
                    <TinyMCEDitor
                      onChange={(e) => StoreEditorValues("Question", e)}
                      PostValue={EditorValues?.Question}
                    />
                    {AQErrors?.Question && (
                      <span className="error-message">
                        {AQErrors?.Question}
                      </span>
                    )}
                  </Col>
                </Row>
              </div>
            )}
          </div>

          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={Q} alt="Question" />{" "}
                <div>
                  Answer<span className="text-danger">*</span>
                </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("Q")} />
            </div>
            {Accordion !== "Q" && (
              <div className="container-fluid mt-2QuestionOptions">
                <Row>
                  {MDQ === "D" && (
                    <Col>
                      <AnswerType disable={GetQuestion?.qUsed}
                        className="NCLDropdown w-100 mb-2"
                        SubjectId="0"
                        LovId="70"
                        PID="0"
                        LID="0"
                        labelname={
                          <div className="DropdownHeader">
                            {" "}
                            Answer Type<span>*</span>{" "}
                          </div>
                        }
                        StoreValue={SetAType}
                        Preselect="true"
                        SOption={AType}
                        onChange={(e) => {
                          SetAType(e);
                          SetUnits("");
                          setMultipleInputs([""]);
                        }}
                        Type="Radio"
                        Name="AType"
                        HideOption="O"
                      />
                      <AnswerValuetype disable={GetQuestion?.qUsed}
                        className="NCLDropdown w-100 mb-2"
                        SubjectId="0"
                        LovId="71"
                        PID="0"
                        LID="0"
                        labelname={
                          <div className="DropdownHeader">
                            {" "}
                            Answer Value Type <span>*</span>{" "}
                          </div>
                        }
                        StoreValue={SetAVType}
                        Preselect="true"
                        SOption={AVType || GetQuestion?.answerValType}
                        onChange={(e) => {
                          SetAVType(e);
                          SetEditorValues({ ...EditorValues, Answer: "" });
                          setMultipleInputs([""]);
                        }}
                        Type="Radio"
                        Name="AVType"
                        HideOption={AType?.Name || ""}
                      />
                      {AType?.Name === "U" && (
                        <>
                          <UnitsDD disabled={GetQuestion?.qUsed}
                            className="NCLDropdown w-100"
                            SubjectId="0"
                            LovId="72"
                            PID={AType?.Value}
                            LID="0"
                            labelname={
                              <div className="DropdownHeader mt-2">
                                {" "}
                                Unit of Measure <span>*</span>
                              </div>
                            }
                            StoreValue={SetUnits}
                            Displayname="Select Units"
                            SOption={Units}
                            onChange={(e) => {
                              SetUnits(e);
                            }}
                            HideOption="O"
                          />
                          {AQErrors?.Units && (
                            <span className="error-message">
                              {AQErrors?.Units}
                            </span>
                          )}
                        </>
                      )}
                    </Col>
                  )}

                  <Col>
                    <div className="dflex JSBetween mt-1">
                      <div className="DropdownHeader">
                        {AVType?.Name === "S" ? "Answer" : "Answers"}{" "}
                        <span>*</span>
                      </div>
                      {AVType?.Name === "M" && MDQ === "D" && (
                        <div className="LinkStyles" onClick={handleAddInput}>
                          Add another answer
                        </div>
                      )}
                    </div>
                    {MDQ === "M" ? (
                      <div className="dflex InputFIlters mt-3 gap-4">
                        <label style={{ backgroundColor: "white" }}>
                          {" "}
                          Select Answer{" "}
                        </label>
                        {["A", "B", "C", "D"].map((option, i) => (
                          <div
                            key={i}
                            className="dflex alignitems gap-2"
                            onChange={() => StoreEditorValues("Answer", option)}
                            style={{ fontSize: "15px" }}
                          >
                            <input disabled={GetQuestion?.qUsed}
                              type="radio"
                              value={option}
                              name="Answer"
                              checked={option == EditorValues?.Answer}
                            />
                            {option}
                          </div>
                        ))}{" "}
                      </div>
                    ) : (
                      <>
                        {(AType?.Name == "T" || AType?.Name == "F") &&
                          AVType?.Name === "S" ? (
                            <div className={`${GetQuestion?.qUsed && "DisabledTiny" }`}>
                          <TinyMCEDitor
                            onChange={(e) => StoreEditorValues("Answer", e)}
                            PostValue={EditorValues?.Answer}
                            disable={AVType == 8409 || GetQuestion?.qUsed}
                          />
                          </div>
                        ) : (
                          <>
                            {AVType?.Name === "M" || AVType?.Name === "S" ? (
                              <>
                                {MultipleInputs.map((input, index) => (
                                  <div key={index} className="RangeInputs">
                                    <input disabled={GetQuestion?.qUsed}
                                      type={InputType(AType?.Name)}
                                    className={`${GetQuestion?.qUsed ? "DisabledNCLDropdown" : "NCLDropdown"} w-100`}
                                      
                                      value={
                                        inputValue(index) ||
                                        MultipleInputs[index]
                                      }
                                      onChange={(e) => handleChange(index, e)}
                                      placeholder="Enter Answer"
                                    />

                                    {index !== 0 && (
                                      <IoIosRemoveCircleOutline
                                        onClick={() => handleRemoveInput(index)}
                                        className="Remove-Input"
                                      />
                                    )}
                                  </div>
                                ))}
                              </>
                            ) : (
                              <>
                                <div>
                                  Range From :
                                  <input disabled={GetQuestion?.qUsed}
                                    type="number"
                                    className={`${GetQuestion?.qUsed ? "DisabledNCLDropdown" : "NCLDropdown"} w-100 mb-3`}

                                    value={RangeValues?.From}
                                    onChange={(e) =>
                                      SetRangevalues({
                                        ...RangeValues,
                                        From: e.target.value.slice(0, 10),
                                      })
                                    }
                                    placeholder="Enter From Value"
                                  />
                                  {AQErrors?.From && (
                                    <span className="error-message">
                                      {AQErrors?.From}
                                    </span>
                                  )}
                                </div>
                                <div>
                                  Range To :
                                  <input disabled={GetQuestion?.qUsed}
                                    type="number"
                                    className={`${GetQuestion?.qUsed ? "DisabledNCLDropdown" : "NCLDropdown"} w-100`}
                                    value={RangeValues?.To}
                                    onChange={(e) =>
                                      SetRangevalues({
                                        ...RangeValues,
                                        To: e.target.value.slice(0, 10),
                                      })
                                    }
                                    placeholder="Enter To Value"
                                  />
                                  {AQErrors?.To && (
                                    <span className="error-message">
                                      {AQErrors?.To}
                                    </span>
                                  )}
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {AVType?.Name !== "M"
                      ? AQErrors?.Answer && (
                        <span className="error-message">
                          {AQErrors?.Answer}
                        </span>
                      )
                      : AQErrors?.MultipleInputs && (
                        <span className="error-message">
                          {AQErrors?.MultipleInputs}
                        </span>
                      )}
                  </Col>
                  {MDQ === "M" && <Col></Col>}
                </Row>

                {MDQ !== "D" && (
                  <>
                    <Row>
                      {["A", "B"].map((item, index) => (
                        <Col key={index}>
                          {" "}
                          <div className="DropdownHeader">
                            Option {item} <span>*</span>{" "}
                          </div>
                          <TinyMCEDitor
                            onChange={(e) =>
                              StoreEditorValues(`Option${item}`, e)
                            }
                            PostValue={EditorValues?.[`Option${item}`]}
                          />
                          {AQErrors?.[`Option${item}`] && (
                            <span className="error-message">
                              {" "}
                              {AQErrors?.[`Option${item}`]}{" "}
                            </span>
                          )}
                        </Col>
                      ))}
                    </Row>

                    <Row>
                      {["C", "D"].map((item, index) => (
                        <Col key={index}>
                          {" "}
                          <div className="DropdownHeader">Option {item} </div>
                          <TinyMCEDitor
                            onChange={(e) =>
                              StoreEditorValues(`Option${item}`, e)
                            }
                            PostValue={EditorValues?.[`Option${item}`]}
                          />{" "}
                        </Col>
                      ))}
                    </Row>
                  </>
                )}
                <Row>
                  {["Explanation", "Misconception"].map((item, index) => (
                    <Col key={index}>
                      {" "}
                      <div className="DropdownHeader">{item} </div>
                      <TinyMCEDitor
                        onChange={(e) => StoreEditorValues(item, e)}
                        PostValue={EditorValues?.[item]}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            )}
          </div>

          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={LO} alt="Learning Outcomes" />{" "}
                <div>Learning Outcomes </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("LOC")} />
            </div>
            {Accordion !== "LOC" && (
              <div className="container-fluid mt-2">
                {items?.subjectId === "2" && (
                  <Row>
                    <Col>
                      <DDSystem
                        Displayname="Select System"
                        className="NCLDropdown w-100"
                        SubjectId={items?.subjectId}
                        StoreValue={SetSSS}
                        SOption={SSS?.System}
                        LID={SelectLanguage}
                        onChange={(e) => StoreSSS("System", e)}
                      />
                      {AQErrors?.System && (
                        <span className="error-message">
                          {AQErrors?.System}
                        </span>
                      )}
                    </Col>
                    <Col>
                      <DDStream
                        // className={`${AQErrors?.Stream ? "ErrorNCLDropdown " : "NCLDropdown"}  w-100`}
                        className="NCLDropdown w-100"
                        SubjectId={items?.subjectId}
                        PId={SSS?.System}
                        StoreValue={SetSSS}
                        SOption={SSS?.Stream}
                        Displayname="Select Stream"
                        LID={SelectLanguage}
                        onChange={(e) => StoreSSS("Stream", e)}
                      />
                      {AQErrors?.Stream && (
                        <span className="error-message">
                          {AQErrors?.Stream}
                        </span>
                      )}
                    </Col>
                    <Col>
                      <DDSubSytem
                        Displayname="Select Sub System"
                        className="NCLDropdown w-100"
                        SubjectId={items?.subjectId}
                        PId={SSS?.Stream}
                        StoreValue={SetSSS}
                        SOption={SSS?.SubSytem}
                        LID={SelectLanguage}
                        onChange={(e) => StoreSSS("SubSytem", e)}
                      />
                      {AQErrors?.SubSytem && (
                        <span className="error-message">
                          {AQErrors?.SubSytem}
                        </span>
                      )}
                    </Col>
                  </Row>
                )}

                <Row>
                  {items?.subjectId === "1" && (
                    <Col>
                      <DDContent
                        Displayname="Select Content"
                        className="NCLDropdown w-100"
                        SubjectId={items?.subjectId}
                        StoreValue={SetContent}
                        SOption={Content}
                        LID={SelectLanguage}
                        onChange={(e) => SetContent(e)}
                      />
                      {AQErrors?.Content && (
                        <span className="error-message">
                          {AQErrors?.Content}
                        </span>
                      )}
                    </Col>
                  )}
                  <Col>
                    <DDTopic
                      className="NCLDropdown w-100"
                      // className={`${AQErrors?.Topic ? "ErrorNCLDropdown " : "NCLDropdown"}  w-100`}
                      SubjectId={items?.subjectId}
                      PId={items?.subjectId === "1" ? "" : SSS?.SubSytem}
                      StoreValue={SeTopic}
                      LID={SelectLanguage}
                      labelName={
                        <div className="DropdownHeader">
                          Topic<span>*</span>
                        </div>
                      }
                      Displayname="Select Topic"
                      SOption={Topic}
                      onChange={(e) => SeTopic(e)}
                      LovCategoryId={items?.subjectId === "1" ? 4 : 25}
                    />
                    {AQErrors?.Topic && (
                      <span className="error-message">{AQErrors?.Topic}</span>
                    )}
                  </Col>
                  <Col>
                    <DDSubTopic
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      PId={Topic}
                      StoreValue={SetSubTopic}
                      SOption={SubTopic}
                      LID={SelectLanguage}
                      labelName={
                        <div className="DropdownHeader">
                          Sub Topic<span>*</span>
                        </div>
                      }
                      Displayname="Select Sub Topic"
                      onChange={(e) => SetSubTopic(e)}
                      LovCategoryId={items?.subjectId === "1" ? 5 : 26}
                    />{" "}
                    {AQErrors?.SubTopic && (
                      <span className="error-message">
                        {AQErrors?.SubTopic}
                      </span>
                    )}
                  </Col>
                  {items?.subjectId !== "1" && <Col></Col>}
                </Row>

                <Row>
                  <Col>
                    <DDLearningOC
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      PId={SubTopic}
                      StoreValue={SetLOC}
                      SOption={LOC}
                      LID={SelectLanguage}
                      labelName={
                        <div className="DropdownHeader">
                          Learning Outcomes<span>*</span>
                        </div>
                      }
                      Displayname="Select Learning Outcomes"
                      onChange={(e) => SetLOC(e)}
                      LovCategoryId={items?.subjectId === "1" ? 40 : 27}
                    />
                    {AQErrors?.LOC && (
                      <span className="error-message">{AQErrors?.LOC}</span>
                    )}
                  </Col>
                  <Col>
                    <DDSubLearningOC
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      PId={LOC}
                      Displayname="Select Sub Learning Outcomes"
                      LID={SelectLanguage}
                      StoreValue={SetSubLOC}
                      SOption={SubLOC}
                      onChange={(e) => SetSubLOC(e)}
                      LovCategoryId={items?.subjectId === "1" ? 41 : 66}
                    />
                    {AQErrors?.SubLOC && (
                      <span className="error-message">{AQErrors?.SubLOC}</span>
                    )}
                  </Col>
                  <Col>
                    <NCERTLO
                      Displayname="Select NCERT Learning Outcome"
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      StoreValue={SetNCERTLOC}
                      SOption={NCERTLOC}
                      LID={SelectLanguage}
                      onChange={(e) => SetNCERTLOC(e)}
                      LovCategoryId={items?.subjectId === "1" ? 8 : 29}
                      GetOptions={SetNCERTDetails}
                    />
                    {AQErrors?.NCERTLOC && (
                      <span className="error-message">
                        {AQErrors?.NCERTLOC}
                      </span>
                    )}
                    <div
                      className="dflex alignitems CPointer gap-1 mt-1"
                      style={{ fontSize: "10px"}}
                      onClick={() => closeNCERTTable(!OpenNCERTTable)}
                    >
                      {" "}
                      <IoInformationCircleOutline /> Click to view NCERT LOs
                      description
                    </div>{" "}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DropdownValues
                      Displayname="Select Chapter"
                      className="NCLDropdown w-100"
                      options={ChapterOpt}
                      selectoption={CNumber}
                      onChange={(e) => SetCNumber(e.target.value)}
                      labelname={
                        <div className="DropdownHeader">
                          CBSE / SCERT Chapter No<span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.CNumber && (
                      <span className="error-message">{AQErrors?.CNumber}</span>
                    )}
                  </Col>
                  <Col>
                    <DropdownValues
                      Displayname="Select Grade"
                      className="NCLDropdown w-100"
                      options={GradeOpt}
                      onChange={(e) => SetGetGrade(e.target.value)}
                      selectoption={GetGrade}
                      labelname={
                        <div className="DropdownHeader">
                          Grade<span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.GetGrade && (
                      <span className="error-message">
                        {AQErrors?.GetGrade}
                      </span>
                    )}
                  </Col>
                  <Col></Col>
                </Row>
              </div>
            )}
          </div>
            <div className="AddOptions">
            <div className="dflex alignitems AUTitles">
              <div className="dflex alignitems">
                <img src={AP} alt="Learning Outcomes" />{" "}
                <div> Competencies<span className="text-danger">*</span></div>
              </div>{" "}
            </div>
            <div className="container-fluid">
              <Row>
                <Col>
                  <StageDD className="NCLDropdown w-100" StoreMSource={SetSStage} SOption={SStage}
                    onChange={(e) => {SetSStage(e);SetSCGoal("");SetCompetencie("");SetFCompetencie("");}} Displayname="Select Stage" LID={items?.subjectId == 1 ? 99 : 102} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Stage<span>*</span> </div>} />
                  {AQErrors?.SStage && (<span className="error-message"> {AQErrors?.SStage} </span>)}
                </Col>
                <Col>
                  <CircularGoalDD className="NCLDropdown w-100" StoreMSource={SetSCGoal} SOption={SCGoal}
                    onChange={(e) => {SetSCGoal(e);SetCompetencie("");}} Displayname="Select Curricular Goal" LID={items?.subjectId == 1 ? 100 : 103} PId={SStage} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Curricular Goal<span>*</span> </div>} GetDetails={SetFSCGoal} />
                  {AQErrors?.SCGoal && (<span className="error-message"> {AQErrors?.SCGoal} </span>)}
                  <div className="dflex alignitems CPointer gap-1 mt-1" style={{ fontSize: "10px" }}
                    onClick={() => SetOpenDeatils(FSCGoal)}
                  > <IoInformationCircleOutline /> Click to view Curricular Goal description </div>
                </Col>
                <Col>
                  <CompetenciesDD className="NCLDropdown w-100" StoreMSource={SetCompetencie} SOption={Competencie}
                    onChange={(e) => SetCompetencie(e)} Displayname="Select Competencies" LID={items?.subjectId == 1 ? 101 : 104} PId={SCGoal} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Competencies<span>*</span> </div>} GetDetails={SetFCompetencie} />
                  {AQErrors?.Competencie && (<span className="error-message"> {AQErrors?.Competencie} </span>)}
                  <div className="dflex alignitems CPointer gap-1 mt-1" style={{ fontSize: "10px" }}
                    onClick={() => SetOpenDeatils(FCompetencie)}
                  > <IoInformationCircleOutline /> Click to view Competencies description </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                <img src={AP} alt="Assessment Parameters" />{" "}
                <div>Assessment Parameters </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("AP")} />
            </div>
            {Accordion !== "AP" && (
              <div className="container-fluid mt-2">
                <Row>
                  <Col>
                    <QuestionLevel
                      Displayname="Select Question Level"
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      StoreValue={SetQLevel}
                      SOption={QLevel}
                      LID={SelectLanguage}
                      onChange={(e) => SetQLevel(e)}
                      LovCategoryId={items?.subjectId === "1" ? 1 : 16}
                      labelname={
                        <div className="DropdownHeader">
                          Question Level <span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.QLevel && (
                      <span className="error-message">{AQErrors?.QLevel}</span>
                    )}
                  </Col>
                  <Col>
                    <BloomTaxonomy
                      Displayname="Select Bloom's Taxonomy"
                      className="NCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      PId={QLevel}
                      StoreValue={SetBTaxonomy}
                      SOption={BTaxonomy}
                      onChange={(e) => SetBTaxonomy(e)}
                      LID={SelectLanguage}
                      LovCategoryId={items?.subjectId === "1" ? 42 : 39}
                      labelname={
                        <div className="DropdownHeader">
                          Bloom's Taxonomy <span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.BTaxonomy && (
                      <span className="error-message">
                        {AQErrors?.BTaxonomy}
                      </span>
                    )}
                  </Col>
                  {items?.subjectId === "1" ? (
                    <Col>
                      <DDContext
                        Displayname="Select Context "
                        className="NCLDropdown w-100"
                        SubjectId={items?.subjectId}
                        StoreValue={SetContext}
                        SOption={Context}
                        LID={SelectLanguage}
                        onChange={(e) => SetContext(e)}
                      />{" "}
                      {AQErrors?.Context && (
                        <span className="error-message">
                          {AQErrors?.Context}
                        </span>
                      )}
                    </Col>
                  ) : (
                    <Col>
                      <DDCompetencies
                        Displayname="Select Competencies"
                        className="NCLDropdown w-100"
                        SubjectId={items?.subjectId}
                        StoreValue={SetCompetencies}
                        SOption={Competencies?.Competencies}
                        LID={SelectLanguage}
                        onChange={(e) => StoreCompetencies("Competencies", e)}
                      />{" "}
                      {AQErrors?.Competencies && (
                        <span className="error-message">
                          {AQErrors?.Competencies}
                        </span>
                      )}
                    </Col>
                  )}
                </Row>
                {items?.subjectId === "2" && (
                  <>
                    {" "}
                    <Row>
                      <Col>
                        <DDSubCompetencies
                          className="NCLDropdown w-100"
                          SubjectId={items?.subjectId}
                          PId={Competencies?.Competencies}
                          StoreValue={SetCompetencies}
                          SOption={Competencies?.SubCompetencies}
                          LID={SelectLanguage}
                          onChange={(e) =>
                            StoreCompetencies("SubCompetencies", e)
                          }
                          Displayname="Select Sub Competencies"
                        />
                        {AQErrors?.SubCompetencies && (
                          <span className="error-message">
                            {AQErrors?.SubCompetencies}
                          </span>
                        )}
                      </Col>
                      <Col>
                        <DDProcedural
                          Displayname="Select Procedural"
                          className="NCLDropdown w-100"
                          SubjectId={items?.subjectId}
                          StoreValue={SetKnowledge}
                          SOption={Knowledge?.Procedural}
                          LID={SelectLanguage}
                          onChange={(e) => StoreKnowledge("Procedural", e)}
                        />
                        {AQErrors?.Procedural && (
                          <span className="error-message">
                            {AQErrors?.Procedural}
                          </span>
                        )}
                      </Col>
                      <Col>
                        <DDEpistemic
                          Displayname="Select Epistemic"
                          className="NCLDropdown w-100"
                          SubjectId={items?.subjectId}
                          PId={Knowledge?.Procedural}
                          StoreValue={SetKnowledge}
                          LID={SelectLanguage}
                          SOption={Knowledge?.Epistemic}
                          onChange={(e) => StoreKnowledge("Epistemic", e)}
                        />{" "}
                        {AQErrors?.Epistemic && (
                          <span className="error-message">
                            {AQErrors?.Epistemic}
                          </span>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <DDContextOne
                          Displayname="Select ContextOne"
                          className="NCLDropdown w-100"
                          SubjectId={items?.subjectId}
                          StoreValue={SetScienceContext}
                          SOption={ScienceContext}
                          LID={SelectLanguage}
                          onChange={(e) => StoreContext("ContextOne", e)}
                        />
                        {AQErrors?.ContextOne && (
                          <span className="error-message">
                            {AQErrors?.ContextOne}
                          </span>
                        )}
                      </Col>
                      <Col>
                        <DDContextTwo
                          Displayname="Select ContextTwo"
                          className="NCLDropdown w-100"
                          SubjectId={items?.subjectId}
                          StoreValue={SetScienceContext}
                          PId={ScienceContext?.ContextOne}
                          SOption={ScienceContext}
                          LID={SelectLanguage}
                          onChange={(e) => StoreContext("ContextTwo", e)}
                        />
                        {AQErrors?.ContextTwo && (
                          <span className="error-message">
                            {AQErrors?.ContextTwo}
                          </span>
                        )}
                      </Col>
                      <Col>
                        <DDContextThree
                          Displayname="Select ContextThree"
                          className="NCLDropdown w-100"
                          SubjectId={items?.subjectId}
                          PIdOne={ScienceContext?.ContextOne}
                          PIdTwo={ScienceContext?.ContextTwo}
                          StoreValue={SetScienceContext}
                          SOption={ScienceContext}
                          LID={SelectLanguage}
                          onChange={(e) => StoreContext("ContextThree", e)}
                        />{" "}
                        {AQErrors?.ContextThree && (
                          <span className="error-message">
                            {AQErrors?.ContextThree}
                          </span>
                        )}
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            )}
          </div>

          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={Forms} alt="Assessment Parameters" />{" "}
                <div>
                  Forms In Question<span className="text-danger">*</span>{" "}
                </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("FQ")} />
            </div>
            {Accordion !== "FQ" && (
              <>
                <FormQuestions
                  PostValues={FormQ}
                  onChange={(e) => FormSOptions(e)}
                  LID={SelectLanguage}
                />
                {FormQ.includes(4002) && (
                  <>
                    <input
                      type="text"
                      className="Search mt-2 p-1 w-100"
                      onChange={(e) => HandelOComments("Form", e.target.value)}
                      placeholder="Enter Comments"
                    />
                    {AQErrors?.Form && (
                      <span className="error-message">{AQErrors?.Form}</span>
                    )}
                  </>
                )}
                {AQErrors?.QForm && (
                  <span
                    className="error-message"
                    style={{ marginLeft: "10px" }}
                  >
                    {AQErrors?.QForm}
                  </span>
                )}
              </>
            )}
          </div>
        </div>
        <QBCList Heading="Question" HValidation={HitCLV} RStoreHValidation={SetHitCLV} VSuccess={SetCValidation}
          GetValues={SetQCValues} Existinvalues={GetQuestion?.status} ExistingId={GetQuestion?.checklistQuestionId}LanguageId={SelectLanguage} />
      
        <div className="ScenarioAU dflex alignitems">
          <button className="Buttons bg-danger" onClick={() => navigate(-1)}>
            Cancel
          </button>
          <button
            className="Buttons bg-success"
            onClick={() => {
              Validation(); SetHitCLV(true);
            }}
          >
            {GetQuestion ? (
              <>
                Update{" "}
                <span style={{ fontSize: "8px" }}>
                  (Please go Through The Below Checklist Before Updating The
                  Question)
                </span>{" "}
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>

      {OpenNCERTTable && (
        <div className="Model-Open">
          <div className="Card w-100 Model-Content">
            <IoMdCloseCircleOutline
              className="NCERTClose CPointer"
              onClick={() => closeNCERTTable(!OpenNCERTTable)}
            />
            <DataTable data={NCERTDetails} columns={NCERTColumns} className="NCLDataTable"
              Dropdownvalues={["10", "25", "50", "100"]} ShowPagination="true" ShowPagecount="true" />
          </div>
        </div>
      )}
 {OpenDeatils && (
        <div className="Model-Open">
          <div className="Card w-100 Model-Content">
            <IoMdCloseCircleOutline
              className="NCERTClose CPointer"
              onClick={() => SetOpenDeatils()}
            />
            <DataTable data={OpenDeatils} columns={Columns} className="NCLDataTable"
              Dropdownvalues={["10", "25", "50", "100"]} ShowPagination="true" ShowPagecount="true" />
          </div>
        </div>
      )}
      {Load && <Loading />}
    </>
  );
};
export default AddUpdateQuestions;
